import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslocoDirective } from "@jsverse/transloco";
import { AccountSelectionService } from "@front/m19-services";
import { toSignal } from "@angular/core/rxjs-interop";
import {
  AlgoModeConfig,
  AlgoModeSelectionComponent,
} from "@m19-board/shared/algo-mode-selection/algo-mode-selection.component";
import { Marketplaces } from "@front/m19-models";
import { FieldTree } from "@angular/forms/signals";

export interface SpCreateStrategyAlgorithmModel {
  algoModeConfig: AlgoModeConfig | null;
}

@Component({
  selector: "app-sp-create-strategy-algorithm",
  imports: [ReactiveFormsModule, TranslocoDirective, AlgoModeSelectionComponent],
  template: ` <div class="flex flex-col gap-8 py-8" *transloco="let t">
    <div class="flex flex-col gap-1">
      <h4>{{ t("common.algorithm") }}</h4>
      <p class="type-body text-muted-foreground m-0">{{ t("strategy-form.algorithm_description") }}</p>
    </div>
    <div class="mb-3 flex">
      <app-algo-mode-selection
        [selectedAlgoModeConfig]="algorithm().algoModeConfig().value() ?? undefined"
        (algoModeConfig)="setAlgoModeConfig($event)"
        [currencyCode]="currencyCode()"
        class="w-full"
      />
    </div>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpCreateStrategyAlgorithmComponent {
  private readonly accountSelectionService = inject(AccountSelectionService);

  readonly algorithm = input.required<FieldTree<SpCreateStrategyAlgorithmModel>>();

  private readonly selectedAccount = toSignal(this.accountSelectionService.singleAccountMarketplaceSelection$, {
    requireSync: true,
  });

  currencyCode = computed(() => Marketplaces[this.selectedAccount().marketplace].currency);

  setAlgoModeConfig(algoModeConfig: Partial<AlgoModeConfig>) {
    this.algorithm()
      .algoModeConfig()
      .value.set(algoModeConfig as AlgoModeConfig);
  }
}
